import { DerechoHabienteModel } from './derecho-habiente.model';

export class PostulanteModel {
    Postulante: number;
    NroPersonal: any;
    DNI: string;
    Nombres: string;
    EmpresaName: string;
    Apellidos: string;
    FullName: string;
    Sede: string;
    FechaPostulacion: string;
    StatusPostulacion_Val: string;
    StatusPostulacion: string;
    CondicionPostulante_Val: string;
    CondicionPostulante: string;
    Cargo_Val: string;
    Cargo: string;
    InicioContrato: string;
    FinContrato: string;
    FechaNacimiento: string;
    Sexo: string;
    Observacion: any;
    URL_FOTO: string;
    Direccion: string;
    TipoContrato: string;
    CodEmpresa: string;
    FechaCaducidad: string;
    ApellidoPaterno: string;
    ApellidoMaterno: string;
    Remuneracion: string;
    Sede_Val: string;
    Edad: number;
    MesesContrato: number;
    Semanas: number;
    FinContratoPrimerDia: string;
    FinMesInicioContrato: string;
    Banco: string;
    NroCuentaCCI: string;
    CategoriaPensionista: string;
    GradoInstruccion: string;
    Sueldo: number;
    EstadoCivil: string;
    EstadoCivilVal: string;
    DireccionActual: string;
    DistritoActual: any;
    ProvinciaActual: any;
    DepartamentoActual: any;
    CategoriaPensionista1: string;
    TipoDocumento: string;
    TipoDocumentoName: string;
    Pais: string;
    NivelEducativo: string;
    NivelEdicativoVAL: string;
    EmpresaVal: number;
    Telefono: string;
    ubigeo: any;
    PeriodoPrueba: string;
    PeriodoPruebaMeses: string;
    PeriodoPrueba6Meses: string;
    PeriodoPrueba12Meses: string;
    DepartamentoDNI: string;
    ProvinciaDNI: string;
    DistritoDNI: string;
    DireccionDNI: string;
    EstadoCivilNS: string;
    NivelEducativoNS: string;
    PaisNS: string;
    TipoDocumentoNS: string;
    Correo: string;
    CategoriaPensionistaNS: string;
    CargoCodigoNS: any;
    NacionalidadNS: string;
    CUSPP: any;
    BancoCodigoNS: string;
    CuentaBancoNS: string;
    ImagenHuella: any;
    direccion_referencia: string;
    CatOcupacional: any;
    CatOcupacionalNombre: any;
    CatOcupacionalValor1: any;
    PeriodPago: any;
    PeriodPagoNombre: any;
    PeriodPagoValor1: any;
    TipoPago: any;
    TipoPagoNombre: any;
    TipoPagoValor1: any;
    SituacEspecial: any;
    SituacEspecialNombre: any;
    SituacEspecialValor1: any;
    TrabHorNocturno: any;
    TrabHorNocturnoNombre: any;
    TrabHorNocturnoValor1: any;
    JornTrabMax: any;
    JornTrabMaxNombre: any;
    JornTrabMaxValor1: any;
    RegAtipico: any;
    RegAtipicoNombre: any;
    RegAtipicoValor1: any;
    CodPlanilla: any;
    CodPlanillaNombre: any;
    CodPlanillaValor1: any;
    CodTipoTrab: any;
    CodTipoTrabNombre: any;
    CodTipoTrabValor1: any;
    CodSucursal: any;
    CodSucursalNombre: any;
    CodSucursalValor1: any;
    GrupoProvision: any;
    GrupoProvisionNombre: any;
    GrupoProvisionValor1: any;
    RegLaboral: any;
    RegLaboralNombre: any;
    RegLaboralValor1: any;
    Empresa: number;
    EmpresaRuc: string;
    EmpresaRazonSocial: string;
    NombreLocalidad: string;
    SubArea: string;
    CategoriaPensionistaName: string;
    PaisNombre: string;
    FechaNacimientoTexto: string;
    Area: string;
    AreaNombre: string;
    AreaValor1: string;
    Subarea: string;
    SubareaNombre: string;
    SubareaValor1: string;
    TipoContratoTrabajador: string;
    TipoCuentaBancaria: string;
    TipoCuentaBancariaNombre: string;
    SedeCiudad: string;
    // Banco: string; 
    BancoNombre: string;
    BancoValor1: string;
    NroCuenta: string;
    BufferFirma: string;
    // NroCuentaCCI: string;

    MonedaNombre: string;
    MonedaSimbolo: string;

    FrutoNombre: string;
    Anio: string;
    FechaActual: string;

    FechaInicioContratoAnterior: string;
    FechaFinContratoAnterior: string;

    TipoTrabajador: string;
    TipoTrabajadorNombre: string;

    Discapacidad:Boolean;
    DescripcionDiscapacidad='';

    EsAlergico:Boolean;
    DetalleAlergia='';

    Telefono2=''; 
    EmergenciaCelular='';
    EmergenciaNombresApellidos='';
    EmergenciaParentesco='';
    UltExpLabEmpresa='';
    UltExpLabFechaFin='';
    UltExpLabFechaInicio='';
    UltExpLabFunciones='';
    UltExpLabMotivoCese='';
    UltExpLabPuesto='';
    Lee:Boolean; 
    Escribe:Boolean;

    PagoBeta = '';
    PagoCtsGratificacion = '';

    TipoTrabajadorDescripcion = '';

    EmpresaDepartamento = '';

    derechoHabientes: Array<DerechoHabienteModel> = [];
}
